export default __webpack_public_path__ + "static/media/19.609973c3.jpg";